import React, { useLayoutEffect, useState } from "react";
import {
  IonAlert,
  IonButton,
  IonButtons,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonModal,
} from "@ionic/react";
import { addOutline, closeOutline, listOutline } from "ionicons/icons";

import { menuController } from "@ionic/core";
import { useContextModals } from "../data/store/useContextModals";
import { useProfile } from "../data/store/useProfile";

import isEmpty from "lodash.isempty";
import { useAlbums } from "../data/store/useAlbums";
import { AlbumId } from "../models/Albums";

interface AvailableAlbums {
  popoverDismiss: () => void;
  popoverState: boolean;
  onClose?: () => void;
}

const AvailableAlbums: React.FC<AvailableAlbums> = ({
  popoverDismiss,
  popoverState,
  onClose,
}) => {
  const { ownerId } = useProfile();
  const [showAlert, setShowAlert] = useState(false);
  const { clearSongModalContext, modalSong } = useContextModals();
  const { fetchAll, isInAlbum, addToAlbum, albumsByUser } = useAlbums();

  const myAlbums = albumsByUser[ownerId];

  const closeAndClear = async () => {
    popoverDismiss();
    clearSongModalContext();
    onClose && onClose();
    await menuController.close();
  };

  const addToMyAlbum = (albumId: AlbumId) => {
    if (isInAlbum(albumId, modalSong.id)) {
      setShowAlert(true);
      return;
    }

    addToAlbum(albumId, modalSong.id).then(() => {
      closeAndClear();
    });
  };

  useLayoutEffect(() => {
    fetchAll();
  }, []);

  return (
    <IonModal
      isOpen={popoverState}
      onDidDismiss={popoverDismiss}
    >
      <IonList>
        <IonItem>
          <IonButtons slot="end">
            <IonButton onClick={popoverDismiss} color="danger" aria-label="Close">
              <IonIcon icon={closeOutline} aria-hidden="true" />
            </IonButton>
          </IonButtons>
        </IonItem>
        <IonItem routerLink="/album-create" onClick={closeAndClear}>
          <IonIcon slot="start" icon={addOutline} aria-hidden="true" />
          <IonLabel>New Album</IonLabel>
        </IonItem>

        {!isEmpty(myAlbums) &&
          myAlbums.map((myAlbums) => (
            <IonItem
              key={myAlbums.id}
              detail={false}
              routerLink="#"
              onClick={() => addToMyAlbum(myAlbums.id)}
            >
              <IonIcon slot="start" icon={listOutline} aria-hidden="true" />
              <IonLabel>{myAlbums.title}</IonLabel>
            </IonItem>
          ))}
      </IonList>

      <IonAlert
        isOpen={showAlert}
        onDidDismiss={() => setShowAlert(false)}
        header="Oops..."
        message="Looks like this song is already in the Album."
        buttons={["OK"]}
      />
    </IonModal>
  );
};

export default AvailableAlbums;
